// React Component for rendering the body of a Group Discussion (aka Topic)
// Used in GroupDiscussionNewsfeedItem and SharingNewsfeedItem with Topic resource

import { PropTypes } from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import GroupIcon from "../../group/group_icon";
import appendQuery from "append-query";
import ExpandableHtml from "../../user_content/expandable_html";
import { ICON_SIZES } from "../../../modules/shape_icon_values";

const URL_REF_BUTTON = "discussion_newsfeed_item_button";
const URL_REF_LINK = "discussion_newsfeed_item_link";

export default GrComponentFactory.createClass({
  displayName: "GroupDiscussionNewsfeedItemBody",

  propTypes: {
    group: GrPropTypes.group().isRequired,
    topic: GrPropTypes.topic().isRequired,
    body: PropTypes.shape(GrPropTypes.expandableHtml()),
  },

  renderFolderTopic() {
    const linkClassName = "gr-hyperlink gr-hyperlink--bold";
    const folder = this.props.topic.folder;
    return (
      <div>
        {"Topic: "}
        <span>
          { folder ?
            <span>
              <a className={linkClassName}
                  href={folder.url}
                  aria-label={`Go to group topic ${folder.name}`}>
                  {folder.name}
              </a>
              <span> &gt; </span>
            </span>
            : null
          }
          <a className={linkClassName}
              href={appendQuery(this.props.topic.url, `ref=${URL_REF_LINK}`)}
              aria-label={`Go to group subtopic ${this.props.topic.title}`}>
              {this.props.topic.title}
          </a>
        </span>
      </div>
    );
  },

  render() {
    return (
      <div>
        <div className="gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter">
          <div className="gr-mediaFlexbox__media">
            <GroupIcon group={this.props.group}
                        size={ICON_SIZES.LARGE} />
          </div>
          <div className="gr-mediaFlexbox__desc gr-h4 gr-h4--noMargin">
            {this.renderFolderTopic()}
          </div>
        </div>
        <div className="u-defaultType">
          <ExpandableHtml {...this.props.body} />
          <a href={appendQuery(this.props.topic.url, `ref=${URL_REF_BUTTON}`)}
              className="gr-button u-marginTopMedium"
              aria-label={`Join the discussion in ${this.props.topic.title}`}>
            Join the discussion
          </a>
        </div>
      </div>
    );
  },
});
